export const options = {
  style: {
    backgroundColor: "#222",
    color: "white",
    fontFamily: '"Noto Sans", sans-serif',
  },
}
